// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.handler

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.InvalidRequestException
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun InvalidRequestException.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "zfb1Q2R8JiYE3FeHUk3cqqon3BgLKBhEaRLJVRQxj84")
val InvalidRequestException_cborSchemaId = ByteString(-51, -10, -11, 67, 100, 124, 38, 38, 4, -36, 87, -121, 82, 77, -36, -86, -86, 39, -36, 24, 11, 40, 24, 68, 105, 18, -55, 85, 20, 49, -113, -50)

fun InvalidRequestException.Companion.fromCbor(data: ByteArray): InvalidRequestException {
    return InvalidRequestException.fromDataItem(Cbor.decode(data))
}

val InvalidRequestException.Companion.cborSchemaId: ByteString
    get() = InvalidRequestException_cborSchemaId

fun InvalidRequestException.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val message = this.message
    if (message != null) {
        builder.put("message", Tstr(message))
    }
    return builder.end().build()
}

fun InvalidRequestException.Companion.fromDataItem(dataItem: DataItem): InvalidRequestException {
    val message0 = if (dataItem.hasKey("message")) {
        dataItem["message"].asTstr
    } else {
        null
    }
    return InvalidRequestException(
        message = message0,
    )
}
